export interface CreateWorkflowFormValues {
  readonly workflowId: string;
  readonly entityType: string;
  readonly entityId: string;
  readonly entityDisplayName: string;
  readonly kind: string;
  readonly title: string;
}

export interface EntityCandidate {
  readonly id: string;
  readonly type: string;
  readonly displayName: string;
  readonly subtitle?: string | null | undefined;
}

export type EntityResolveStatus =
  "Resolved" | "NotFound" | "Unavailable" | "UnsupportedType" | null;

export interface CreateWorkflowDialogProps {
  readonly isOpen: boolean;
  readonly isSubmitting: boolean;
  readonly errorMessage: string | null;
  /**
   * Kinds the backend accepts, sourced from the `/workflow-kinds` endpoint.
   * The dialog renders one choice chip per kind, labelled by the humanized slug.
   */
  readonly availableKinds: readonly string[];
  readonly onClose: () => void;
  readonly onSubmit: (values: CreateWorkflowFormValues) => void;

  readonly entityCandidates: readonly EntityCandidate[];
  readonly entityCandidatesLoading: boolean;
  readonly onEntitySearch: (type: string, query: string) => void;

  readonly entityResolveStatus: EntityResolveStatus;
  readonly entityResolveLoading: boolean;
  readonly onEntityResolve: (type: string, id: string) => void;

  /**
   * Top-level workflows already on the resolved entity. Shown above Kind
   * so the caller can open an existing thread instead of creating another.
   */
  readonly existingWorkflows?: readonly ExistingEntityWorkflow[];
  readonly existingWorkflowsLoading?: boolean;
  readonly onOpenExisting?: (workflow: ExistingEntityWorkflow) => void;
}

/** A thread already anchored to the entity the dialog has resolved. */
export interface ExistingEntityWorkflow {
  readonly id: string;
  readonly title: string;
  readonly kind: string;
  readonly entityType: string;
  readonly entityId: string;
}

/** Fixed entity vocabulary plus a freeform "other" entry. */
export const KNOWN_ENTITY_TYPES = ["customer", "carrier", "order", "load", "facility"] as const;

export const CUSTOM_ENTITY_TYPE = "__custom__";

/** A search query shorter than this does not open the candidate list. */
export const MIN_SEARCH_LENGTH = 2;
